import { render, staticRenderFns } from "./ProgressReport.vue?vue&type=template&id=72dacbee&"
import script from "./ProgressReport.vue?vue&type=script&lang=js&"
export * from "./ProgressReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports